import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import classes from './TablaVentasDeVendedoresPorSeleccion.css';

import * as actions from '../../../../store/actions/index';
import { formatNumber, isEven } from '../../../../shared/formatNumber';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import FilterListIcon from '@material-ui/icons/FilterList';
import { IconButton, Tooltip } from '@material-ui/core';
import Table from '../../../UI/Table/Table';
import TablaVentasPorVendedorDeLaSeleccion from '../TablaVentasPorVendedorDeLaSeleccion/TablaVentasPorVendedorDeLaSeleccion';
import TablaVentasPorClienteDelVendedor from '../TablaVentasPorClienteDelVendedor/TablaVentasPorClienteDelVendedor';
import WrapperTablasPorSeleccionSinComparacionToExcel from '../../Ventas/WrapperTablasPorSeleccionSinComparacionToExcel/WrapperTablasPorSeleccionSinComparacionToExcel';

const TablaVentasDeVendedoresPorSeleccion = (props) => {
  const { dataSelectedId, fechaVentasDelMes } = props;

  useEffect(() => {
    if (!props[dataOptions()[dataSelectedId].stateKey].estaCargado && props.ejecucionDePagina) {
      props[dataOptions()[dataSelectedId].onLoadKey](fechaVentasDelMes.mes + 1, fechaVentasDelMes.anio);
    }
  }, [dataSelectedId, props.ejecucionDePagina]);

  const dataOptions = (item) => {
    return {
      categoriaDeCliente: {
        title: 'Categoría de cliente',
        stateKey: 'ventasPorCategoriaDeCliente',
        onLoadKey: 'onLoadVentasPorCategoriasDeCliente'
      },
      marca: {
        title: 'Marca',
        stateKey: 'ventasPorMarca',
        onLoadKey: 'onLoadVentasPorMarca'
      },
      rubro: {
        title: 'Rubro',
        stateKey: 'ventasPorRubro',
        onLoadKey: 'onLoadVentasPorRubro'
      },
      subrubro: {
        title: 'Subrubro',
        stateKey: 'ventasPorSubrubro',
        onLoadKey: 'onLoadVentasPorSubrubro'
      },
      vendedor: {
        title: 'Vendedor',
        stateKey: 'ventasPorVendedor',
        onLoadKey: 'onLoadVentasPorVendedor'
      },
      provincia: {
        title: 'Provincia',
        stateKey: 'ventasPorProvincia',
        onLoadKey: 'onLoadVentasPorProvincia'
      },
      zona: {
        title: 'Zona',
        stateKey: 'ventasPorZona',
        onLoadKey: 'onLoadVentasPorZona'
      }
    };
  };

  const columns = [
    {
      title: dataOptions()[dataSelectedId].title,
      field: 'name',
      align: 'left',
      cellStyle: {
        fontSize: '12px',
        paddingBottom: '5px',
        paddingTop: '5px'
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: '#fafafa'
      }
    },
    {
      title: `Porc. participación`,
      field: 'porcParticipacion',
      align: 'right',
      type: 'numeric',
      cellStyle: (cellData) => {
        return {
          fontSize: '12px',
          paddingBottom: '5px',
          paddingTop: '5px',
          color: cellData < 0 && 'red'
        };
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: '#fafafa'
      },
      render: (rowData) => `${formatNumber(rowData.porcParticipacion)}%`
    },
    {
      title: `Monto`,
      field: 'monto',
      align: 'right',
      type: 'numeric',
      cellStyle: (cellData) => {
        return {
          fontSize: '12px',
          paddingBottom: '5px',
          paddingTop: '5px',
          color: cellData < 0 && 'red'
        };
      },
      headerStyle: {
        fontSize: '14px',
        paddingTop: '0px',
        paddingBottom: '0px',
        backgroundColor: '#fafafa'
      },
      render: (rowData) => `${storageMonedaSigno()} ${formatNumber(rowData.monto)}`
    }
  ];

  const data = () => {
    return props[dataOptions()[dataSelectedId].stateKey].ventas.map((venta) => {
      return {
        id: venta[inCategoriaDeCliente ? 'idCategoria' : 'id'],
        mes: venta.mes,
        anio: venta.anio,
        name: venta[inCategoriaDeCliente ? 'categoria' : 'nombre'],
        porcParticipacion: venta.porcentajeDeParticipacion,
        monto: venta.monto
      };
    });
  };
  const inCategoriaDeCliente = dataSelectedId === 'categoriaDeCliente';
  const inVendedores = dataSelectedId === 'vendedor';

  const tableRef = useRef();

  const autoScroll = (rowData) => {
    if (tableRef.current) {
      const indexRow = tableRef.current.state.data.indexOf(tableRef.current.state.originalData[rowData.tableData.id]);

      tableRef.current.tableContainerDiv.current.scrollTop = 49 * indexRow;
    }
  };

  return (
    <div className={classes.TablaVentasDeVendedoresPorSeleccionContainer}>
      <div className={classes.TitleCard}>
        {!props[dataOptions()[dataSelectedId].stateKey].loading && (
          <WrapperTablasPorSeleccionSinComparacionToExcel
            ventas={data()}
            fecha={`${fechaVentasDelMes.mes}/${fechaVentasDelMes.anio}`}
            ventasDe={dataOptions()[dataSelectedId].title}
          />
        )}
        <Tooltip title="Ver filtros del indicador">
          <IconButton size="small" onClick={() => props.onShowFiltersModal()}>
            <FilterListIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      <Table
        tableRef={tableRef}
        title=""
        loading={props[dataOptions()[dataSelectedId].stateKey].loading}
        columns={columns}
        data={data()}
        detailPanel={(rowData) => {
          setTimeout(() => {
            autoScroll(rowData);
          }, 100);

          return inVendedores ? (
            <TablaVentasPorClienteDelVendedor
              endRequest={() => autoScroll(rowData)}
              vendedorId={rowData.id}
              mes={rowData.mes}
              anio={rowData.anio}
              dataSelectedId={dataSelectedId}
            />
          ) : (
            <TablaVentasPorVendedorDeLaSeleccion
              endRequest={() => autoScroll(rowData)}
              dataSelectedId={dataSelectedId}
              itemExpanded={rowData}
            />
          );
        }}
        noBoxShadow
        customOptions={{
          thirdSortClick: false,
          sorting: true,
          grouping: false,
          draggable: false,
          search: false,
          paging: false,
          toolbar: false,
          showTitle: false,
          maxBodyHeight: 430,
          rowStyle: (rowData) => ({
            color: rowData.tableData.monto < 0 && 'red',
            backgroundColor: !isEven(rowData.tableData.id) && '#f2f2f2'
          })
        }}
        tableKey={"tabla-ventas-vendedores-por-seleccion"}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dataSelectedId: state.vendedores.dataVentasDelMesDeVendedoresPorSelected,

    fechaVentasDelMes: state.vendedores.fechaVentasDelMesAnioDeVendedores,

    ventasPorCategoriaDeCliente: state.vendedores.ventasDeVendedoresDelMesPorCategoriaDeCliente,
    ventasPorMarca: state.vendedores.ventasDeVendedoresDelMesPorMarcas,
    ventasPorProvincia: state.vendedores.ventasDeVendedoresDelMesPorProvincias,
    ventasPorRubro: state.vendedores.ventasDeVendedoresDelMesPorRubros,
    ventasPorSubrubro: state.vendedores.ventasDeVendedoresDelMesPorSubrubros,
    ventasPorVendedor: state.vendedores.ventasDeVendedoresDelMesPorVendedores,
    ventasPorZona: state.vendedores.ventasDeVendedoresDelMesPorZonas
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeOptionSelected: (selecionId) => dispatch(actions.seleccionDataVentasDelMesPor(selecionId)),

    onLoadVentasPorCategoriasDeCliente: (mes, anio) =>
      dispatch(actions.loadVentasDeVendedoresPorCategoriaDeCliente(mes, anio)),

    onLoadVentasPorMarca: (mes, anio) => dispatch(actions.loadVentasDeVendedoresDelMesPorMarca(undefined, mes, anio)),

    onLoadVentasPorRubro: (mes, anio) => dispatch(actions.loadVentasDeVendedoresDelMesPorRubro(undefined, mes, anio)),

    onLoadVentasPorSubrubro: (mes, anio) =>
      dispatch(actions.loadVentasDeVendedoresDelMesPorSubrubro(undefined, mes, anio)),

    onLoadVentasPorVendedor: (mes, anio) => dispatch(actions.loadVentasDeVendedoresDelMesPorVendedor(mes, anio)),

    onLoadVentasPorProvincia: (mes, anio) =>
      dispatch(actions.loadVentasDeVendedoresDelMesPorProvincia(undefined, mes, anio)),

    onLoadVentasPorZona: (mes, anio) => dispatch(actions.loadVentasDeVendedoresDelMesPorZona(undefined, mes, anio)),

    onShowFiltersModal: () =>
      dispatch(actions.showListFiltersModal(true, 'Ventas detalladas por categoría de cliente', ['venta']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablaVentasDeVendedoresPorSeleccion);
